import React from "react";
import BreadCrumbs from "../../../Utils/Common/Breadcrumb";
import CollapsibleTable from ".";
// import TestSetupExpendablesRows from './TestSetupExpendablesRows/TestSetupExpendablesRows';

export const OncologyResultFileUpload = () => {
  return (
    <>
      <div className="app-toolbar py-2 py-lg-3">
        <div className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
          <BreadCrumbs />
        </div>
      </div>
      <CollapsibleTable />
    </>
  );
};
export default OncologyResultFileUpload;
